import { computed } from 'vue'

// v2 dark mode (Wave 7 / V28) — thin wrapper over @nuxtjs/color-mode's useColorMode()
// so SFCs stay off the module API directly. `useColorMode` is auto-imported by the module.
//   - theme:      bindable user preference ('system' | 'light' | 'dark')
//   - isDark:     resolved theme is dark (preference may be 'system')
//   - toggle():   instant light↔dark flip off the currently-resolved value
export const useTheme = () => {
  const colorMode = useColorMode()

  const isDark = computed(() => colorMode.value === 'dark')

  const theme = computed({
    get: () => colorMode.preference,
    set: (value: string) => {
      colorMode.preference = value
    },
  })

  const toggle = () => {
    colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
  }

  return { colorMode, theme, isDark, toggle }
}
